"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require("redbox-react");

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require("react");

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require("react-transform-catch-errors");

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class;

var _reactRedux = require("react-redux");

var _selectors = require("selectors");

var _components2 = require("components");

var _pacomo = require("utils/pacomo");

var _userActions = require("actions/userActions");

var _utilityFunctions = require("utils/utilityFunctions");

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    UserComplete: {
        displayName: "UserComplete"
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: "/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/UserComplete.js",
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var UserComplete = _wrapComponent("UserComplete")((0, _pacomo.pacomoDecorator)(_class = function (_Component) {
    (0, _inherits3.default)(UserComplete, _Component);

    function UserComplete(props) {
        (0, _classCallCheck3.default)(this, UserComplete);

        /*
        Changing states:
            1. Flipped - User clicks on "Close" button
            2. Complete - 3 seconds after "Flipped"
            3. Hidden - 1 second after "Complete"
        */
        var _this = (0, _possibleConstructorReturn3.default)(this, (UserComplete.__proto__ || (0, _getPrototypeOf2.default)(UserComplete)).call(this, props));

        _this.flipCard = function () {
            _this.setState({
                flipped: true
            });
            // The component will animate closed after 3 seconds...
            setTimeout(function () {
                this.setState((0, _extends3.default)({}, this.state, {
                    closed: true
                }));
                this.props.dispatch((0, _userActions.hideUserCompletePrompt)());
            }.bind(_this), 3000);
            // And hide 1 second after that
            setTimeout(function () {
                this.setState((0, _extends3.default)({}, this.state, {
                    hidden: true
                }));
            }.bind(_this), 4000);
        };

        _this.isUserG2G = function () {
            var _this$props = _this.props,
                requirementSetsByCustomerId = _this$props.requirementSetsByCustomerId,
                user = _this$props.user;

            if (user && user.customerId) {
                if ((0, _utilityFunctions.isUserG2G)(requirementSetsByCustomerId[user.customerId])) {
                    _this.setState((0, _extends3.default)({}, _this.state, {
                        complete: true,
                        hidden: false,
                        closed: false,
                        flipped: false
                    }));
                    document.documentElement.scrollTop = 0;
                    _this.props.dispatch((0, _userActions.userComplete)());
                    return true;
                }
            }
            return false;
        };

        _this.getTourName = function () {
            var departureServices = _this.props.departureServices;

            var services = [];
            (0, _keys2.default)(departureServices).map(function (id) {
                if (departureServices[id].type == "departure_services") {
                    services.push(departureServices[id]);
                }
            });
            return services && services[0] && services[0]["name"];
        };

        _this.state = {
            flipped: false,
            complete: false,
            hidden: false
        };
        return _this;
    }

    // Determins if the current user is G2G Complete
    // Also sets the global UI state so other parts of the app
    // Can respond appropriately


    (0, _createClass3.default)(UserComplete, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (this.props.requirementSetsByCustomerId !== prevProps.requirementSetsByCustomerId) {
                this.isUserG2G();
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                passengersById = _props.passengersById,
                user = _props.user;


            if (this.state.complete) {
                var tourName = this.getTourName();
                var pax = passengersById[user.customerId];

                return _react3.default.createElement(
                    "div",
                    {
                        className: "" + (this.state.hidden ? "hidden " : "") + (this.state.closed ? "closed " : "") + (this.state.flipped ? "flipped " : "")
                    },
                    _react3.default.createElement(
                        "div",
                        {
                            className: "flip-container " + (this.state.flipped ? "hover" : "")
                        },
                        _react3.default.createElement(
                            "div",
                            { className: "flipper" },
                            _react3.default.createElement(
                                "div",
                                { className: "front" },
                                _react3.default.createElement(
                                    "h1",
                                    null,
                                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: "UserComplete.front.h1",
                                        defaultMessage: "Congratulations"
                                    })
                                ),
                                _react3.default.createElement(
                                    "p",
                                    { className: "subtitle" },
                                    pax && pax.name.legal_first_name,
                                    " \xA0",
                                    " ",
                                    pax && pax.name.legal_last_name
                                ),
                                _react3.default.createElement(
                                    "div",
                                    { className: "content" },
                                    _react3.default.createElement(
                                        "div",
                                        { className: "heading" },
                                        _react3.default.createElement(_reactIntl.FormattedMessage, {
                                            id: "UserComplete.front.heading",
                                            defaultMessage: "You're Good To Go!"
                                        })
                                    )
                                ),
                                _react3.default.createElement(
                                    "div",
                                    { className: "bottom" },
                                    _react3.default.createElement(
                                        "div",
                                        {
                                            className: "close",
                                            onClick: function onClick() {
                                                _this2.flipCard();
                                            }
                                        },
                                        _react3.default.createElement(_reactIntl.FormattedMessage, {
                                            id: "UserComplete.front.close",
                                            defaultMessage: "Close"
                                        })
                                    )
                                )
                            ),
                            _react3.default.createElement(
                                "div",
                                { className: "back" },
                                _react3.default.createElement(
                                    "h1",
                                    null,
                                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: "UserComplete.back.message",
                                        defaultMessage: "You're on your way to"
                                    })
                                ),
                                _react3.default.createElement(
                                    "p",
                                    { className: "subtitle" },
                                    tourName
                                )
                            )
                        )
                    )
                );
            } else {
                return _react3.default.createElement("div", { className: "hidden" });
            }
        }
    }]);
    return UserComplete;
}(_react2.Component)) || _class);

var mapStateToProps = function mapStateToProps(state) {
    return {
        requirementSetsByCustomerId: (0, _selectors.getRequirementSetsByCustomerId)(state),
        passengersById: (0, _selectors.getCustomersById)(state),
        user: state.user,
        departureServices: state.departureServices
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(UserComplete);
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/components/UserComplete.js
// module id = 1336
// module chunks = 0